import React, { FC } from 'react';

import { Col, Row } from 'antd';
import { FormattedMessage } from 'react-intl';

export type CampaignLabelStatus = 'completed' | 'error' | 'plain';

interface OwnProps {
  bottomLabel?: {
    label: string;
    style: CampaignLabelStatus;
  };
  children: JSX.Element;
  description?: string;
  icon?: string;
  id?: string;
  isBlocked?: boolean;
  points?: string; // * TODO: Set icon as prop of every "resource" in "IChallengeResourceConfig"
  styleClass?: string;
  title?: string;
}

const FormationResourceWrapper: FC<OwnProps> = ({
  bottomLabel,
  children,
  description,
  icon,
  id,
  isBlocked,
  points,
  styleClass,
  title,
}) => {
  return (
    <>
      <Row
        align="top"
        className={`formationResourceWrapper ${styleClass} `}
        id={id}
        justify="center"
      >
        {isBlocked && (
          <div className="formationResourceWrapper__blocked-overlay" />
        )}
        <Col className="formationResourceWrapper__container">
          {icon && (
            <Row justify="center" className="formationResourceWrapper__icon">
              <div className={`icon icon--${icon}`} />
            </Row>
          )}
          {points && (
            <Row
              justify="center"
              align="middle"
              className="formationResourceWrapper__points"
            >
              <div className="icon icon--puntos" />
              {points}
            </Row>
          )}
          {title && (
            <Row justify="center" className="formationResourceWrapper__title">
              {title}
            </Row>
          )}
          {description && (
            <Row
              className="formationResourceWrapper__description"
              justify="center"
            >
              {description}
            </Row>
          )}
          {children}
          {bottomLabel && (
            <Row justify="center" align="middle">
              <div
                className={`formationResourceWrapper__label challengeResourceWrapper__label--${bottomLabel.style}`}
              >
                <FormattedMessage id={bottomLabel.label} />
              </div>
            </Row>
          )}
        </Col>
      </Row>
    </>
  );
};

export default FormationResourceWrapper;

export const FormationResourceWrapperBlocked: FC<{}> = () => {
  return (
    <Row
      align="middle"
      justify="center"
      className="formationResourceWrapper__blocked-icon"
    >
      <img className="icon icon--padlock--blocked-module icon__size-120" />
    </Row>
  );
};
